__turbopack_context__.v({
  "bandHeader": "index-module-scss-module__8hR93W__bandHeader",
  "card": "index-module-scss-module__8hR93W__card",
  "earnBuzzCard": "index-module-scss-module__8hR93W__earnBuzzCard",
  "earnCard": "index-module-scss-module__8hR93W__earnCard",
  "getPaidCard": "index-module-scss-module__8hR93W__getPaidCard",
  "highlightCard": "index-module-scss-module__8hR93W__highlightCard",
  "highlightCardBackgroundIcon": "index-module-scss-module__8hR93W__highlightCardBackgroundIcon",
  "highlightColor": "index-module-scss-module__8hR93W__highlightColor",
  "mantine-Title-root": "index-module-scss-module__8hR93W__mantine-Title-root",
  "newPerksCard": "index-module-scss-module__8hR93W__newPerksCard",
  "programBand": "index-module-scss-module__8hR93W__programBand",
  "section": "index-module-scss-module__8hR93W__section",
});
